import { InputSelect } from '@lmc/ui-kit'
import useJobTitles from 'hooks/useUser/useJobTitles'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import type { ComponentType, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { FormFieldLayout } from '../../../generic'

// FormFieldLayout is a legacy JS component typed only via PropTypes; give it a
// narrow prop type so it can be used from this typed component.
const FieldLayout = FormFieldLayout as unknown as ComponentType<{
  label?: string
  required?: boolean
  note?: ReactNode
  children?: ReactNode
}>

type JobTitleFieldProps = {
  value?: string
  onChange: (value: string) => void
  testId?: string
}

const JobTitleField = ({
  value,
  onChange,
  testId = 'job-title'
}: JobTitleFieldProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)
  const { jobTitles } = useJobTitles()

  const options = jobTitles.map((title) => ({ label: title, value: title }))

  // antd tags mode emits an array; keep the last entry as the single job title
  // (mirrors the Add-member wizard's handleJobTitleChange, capped at 100 chars).
  const handleChange = (val: string[] | string) => {
    const arr = Array.isArray(val) ? val : [val]
    const next = (arr[arr.length - 1] ?? '').toString().slice(0, 100)
    onChange(next)
  }

  // FormFieldLayout supplies the label-left column (shared with the other
  // fields) and renders the hint under the input via `note`. InputSelect itself
  // is label-less so it sits in the input column like the sibling fields.
  return (
    <FieldLayout
      label="Job title"
      required
      note={t(reportsConstants.JOB_TITLE_HINT)}
    >
      <InputSelect
        testId={testId}
        type="jobTitle"
        layout="column"
        showSearch
        mode="tags"
        options={options}
        value={value ? [value] : []}
        onChange={handleChange}
      />
    </FieldLayout>
  )
}

export default JobTitleField
